import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/home'

import VueGtag from "vue-gtag";


import { store } from '@/store/store.js';

import categoria from '@/components/views/categoria';
import actividad from '@/components/views/actividad';
import vivirExperiencias from '@/components/views/vivir-experiencias';
import comoinscribirte from '@/components/views/como-inscribirte';
import proximamente from '@/components/views/proximamente';
import registro from '@/components/views/registro';
import mapaweb from '@/components/views/mapa-web';
import buscador from '@/components/views/buscador';
import accesibilidad from '@/components/views/accesibilidad';

import politicaCookies from '@/components/views/politica-de-cookies'
import politicaPrivacidad from '@/components/views/politica-de-privacidad'

Vue.use(Router)


import messages from '@/translations';

let en = messages.en.enlaces;
let es = messages.es.enlaces;

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},

		{
			path: `${es.categoria}/:id?`,
			name: 'categoria',
			component: categoria
		},
		{
			path: `${es.actividad}/:id?`,
			name: 'actividad',
			component: actividad
		},
		{
			path: es.vivir_experiencias,
			name: 'vivir-experiencias',
			component: vivirExperiencias
		},
		{
			path: es.como_inscribirte,
			name: 'como-inscribirte',
			component: comoinscribirte
		},
		{
			path: es.politica_privacidad,
			alias: en.politica_privacidad,
			name: 'politica-de-privacidad',
			component: politicaPrivacidad
		},
		{
			path: es.politica_cookies,
			alias: en.politica_cookies,
			name: 'politica-de-cookies',
			component: politicaCookies
		},
		{
			path: es.proximamente,
			alias: en.proximamente,
			name: 'proximamente',
			component: proximamente
		},
		{
			path: es.registro,
			alias: en.registro,
			name: 'registro',
			component: registro
		},
		{
			path: '/mapa-web',
			name: 'mapaweb',
			component: mapaweb
		},
		{
			path: '/accesibilidad',
			name: 'accesibilidad',
			component: accesibilidad
		},
		{
			path: '/buscador',
			name: 'buscador',
			component: buscador
		},
		{ path: '*', redirect: '/' },
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
});

import VueAnalytics from 'vue-analytics';

Vue.use(VueAnalytics, {
	id: 'UA-170902479-1',
	router,
	debug: { sendHitTask: location.hostname.includes('experiencias.jaenparaisointerior.es') }
});

// Vue.use(VueGtag, {
// 	config: { id: "AW-789750121" }
//   });

router.beforeEach((to, from, next) => {
	next();
});

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js